(function () {
  // ---------------- utils ----------------
  function toKey(u) {
    try {
      var x = new URL(u, window.location.origin);
      var p = x.pathname.replace(/\/+$/, '');
      return (p || '/') + (x.search || '');
    } catch (e) {
      return (u || '').replace(/\/+$/, '');
    }
  }
  function closest(el, sel) { return el ? el.closest(sel) : null; }

  // =========================================================
  // DESKTOP: toggle + cerrar otros abiertos
  // =========================================================
  function setAnimState(container, open) {
    if (!container) return;
    if (open) container.setAttribute('data-animation-state', 'open');
    else container.removeAttribute('data-animation-state');
  }
  function toggleDesktop(detailsEl, summaryEl) {
    if (!detailsEl || !summaryEl) return;
    var willOpen = !detailsEl.hasAttribute('open');

    // Cierra TODOS los demás abiertos (en sticky + header normal)
    document.querySelectorAll('details[data-nav-desktop-details][open]').forEach(function (d) {
      if (d === detailsEl) return;
      d.open = false;
      var s = d.querySelector('summary[data-nav-desktop-link]');
      if (s) s.setAttribute('aria-expanded', 'false');
      var c = d.querySelector('[data-meganav-target-container]') || d.querySelector('[data-nav-desktop-submenu]');
      setAnimState(c, false);
      d.classList.remove('is-open');
    });

    // Toggle actual
    if (willOpen) detailsEl.setAttribute('open','open'); else detailsEl.removeAttribute('open');
    summaryEl.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    var container = detailsEl.querySelector('[data-meganav-target-container]') || detailsEl.querySelector('[data-nav-desktop-submenu]');
    setAnimState(container, willOpen);
    detailsEl.classList.toggle('is-open', willOpen);
  }
  function isMeganavParentSummary(summary) {
    var details = closest(summary, 'details[data-nav-desktop-details]');
    return !!(details && (details.querySelector('[data-meganav-target-container]') || details.querySelector('[data-nav-desktop-full-width-menu]')));
  }
  function installDesktopInterceptors() {
    // Capturamos antes que el tema y hacemos el toggle + cierre de hermanos
    document.addEventListener('click', function (e) {
      var summary = e.target && e.target.closest('summary[data-nav-desktop-link]');
      if (!summary || !isMeganavParentSummary(summary)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggleDesktop(closest(summary, 'details[data-nav-desktop-details]'), summary);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var summary = e.target && e.target.closest('summary[data-nav-desktop-link]');
      if (!summary || !isMeganavParentSummary(summary)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggleDesktop(closest(summary, 'details[data-nav-desktop-details]'), summary);
    }, true);
  }

  // =========================================================
  // MOBILE: neutralizar enlace del parent (excepto CTA)
  // - Funciona aunque el tema reinyecte targets con MeganavManager
  // =========================================================
  function neutralizeMobileForHandle(handle, parentUrl) {
    var parentKey = toKey(parentUrl);
    // targets móviles donde se inyecta el item de nivel 1
    var targets = document.querySelectorAll('[data-meganav-mobile-target="' + handle + '"]');

    targets.forEach(function (target) {
      // 1) data-href (tema navega leyendo dataset.href)
      target.querySelectorAll('[data-href]').forEach(function (el) {
        var dh = (el.dataset && el.dataset.href) || '';
        if (toKey(dh) === parentKey) {
          el.dataset.href = 'javascript:void(0)'; // neutraliza navegación
          el.setAttribute('data-neutralized-parent-href','1');
        }
      });
      // 2) anchors normales (por si acaso)
      target.querySelectorAll('a[href]').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (toKey(href) === parentKey) {
          // no tocar CTA si lo tienes en mobile dentro de este target (suele estar fuera)
          if (a.closest('.mobile-mega-menu__cta')) return;
          a.setAttribute('href','#');
          a.setAttribute('data-neutralized-parent-link','1');
          a.setAttribute('role','button');
          a.setAttribute('aria-disabled','true');
        }
      });
    });
  }
  function scanAndNeutralizeMobile() {
    // toma cada sección de mega menú para leer handle + parent_url
    document.querySelectorAll('.shopify-section--mega-menu').forEach(function (sec) {
      var mobile = sec.querySelector('[data-meganav-mobile][data-meganav-handle]');
      var desktop = sec.querySelector('[data-meganav-desktop][data-meganav-handle]');
      var handle = mobile ? mobile.getAttribute('data-meganav-handle') :
                   desktop ? desktop.getAttribute('data-meganav-handle') : null;
      // lee parent_url de cualquiera de los dos contenedores
      var parentUrl = (mobile && mobile.getAttribute('data-parent-url')) ||
                      (desktop && desktop.getAttribute('data-parent-url')) || '';
      if (!handle || !parentUrl) return;
      neutralizeMobileForHandle(handle, parentUrl);
    });
  }
  function installMobileInterceptors() {
    // Evita navegación SOLO en elementos neutralizados (deja burbujeo para el acordeón)
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-neutralized-parent-link="1"], [data-neutralized-parent-href="1"]')) {
        e.preventDefault(); // no navegación
      }
    }, true);

    // Re-aplica al reinyectar DOM (sticky header, drawer, etc.)
    var mo = new MutationObserver(function (mutations) {
      var shouldRescan = mutations.some(function (m) {
        return Array.from(m.addedNodes || []).some(function (n) {
          return n.nodeType === 1 && (
            n.matches?.('[data-meganav-mobile-target], .shopify-section--mega-menu') ||
            n.querySelector?.('[data-meganav-mobile-target], .shopify-section--mega-menu')
          );
        });
      });
      if (shouldRescan) scanAndNeutralizeMobile();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Primera pasada
    scanAndNeutralizeMobile();
  }
  // --- cerrar TODOS los detalles abiertos (desktop)
function closeAllDesktop() {
  document.querySelectorAll('details[data-nav-desktop-details][open]').forEach(function (d) {
    d.open = false;
    var s = d.querySelector('summary[data-nav-desktop-link]');
    if (s) s.setAttribute('aria-expanded', 'false');
    var c = d.querySelector('[data-meganav-target-container]') || d.querySelector('[data-nav-desktop-submenu]');
    setAnimState(c, false);     // reusa la util que ya definimos
    d.classList.remove('is-open');
  });
}

// --- instalar cierre al click/focus fuera del nav desktop
function installOutsideCloseDesktop() {
  var handler = function (e) {
    // Si el click/focus ocurre dentro del nav desktop (incluye el mega), no cerramos
    if (e.target.closest && e.target.closest('[data-nav-desktop]')) return;
    closeAllDesktop();
  };
  // Usamos captura para adelantarnos a otros listeners del tema
  document.addEventListener('mousedown', handler, true);
  document.addEventListener('touchstart', handler, true);
  document.addEventListener('focusin', handler, true);
}


  // init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      installDesktopInterceptors();
      installMobileInterceptors();
      installOutsideCloseDesktop();
    });
  } else {
    installDesktopInterceptors();
    installMobileInterceptors();
    installOutsideCloseDesktop();
  }
})();

(function patchMobileParents(){
  var root = document.getElementById('mobile_menu');
  if (!root) return;

  function toggleSubmenu(e){
    var a = e.target.closest('li.sublink > a.parent-link--true, li.sublink > a.parent-link--false');
    if (!a || !root.contains(a)) return;

    // Hay un submenu justo después del <a>
    var li = a.closest('li.sublink');
    var submenu = a.nextElementSibling && a.nextElementSibling.matches('ul.mobile-mega-menu')
      ? a.nextElementSibling
      : li.querySelector('ul.mobile-mega-menu');

    if (!submenu) return;

    // Evita navegación y propagación
    e.preventDefault();
    e.stopPropagation();

    var isOpen = getComputedStyle(submenu).display !== 'none';

    // Cierra hermanos (acordeón)
    root.querySelectorAll('li.sublink > ul.mobile-mega-menu').forEach(function(ul){
      if (ul !== submenu) {
        ul.style.display = 'none';
        var pli = ul.closest('li.sublink');
        if (pli) {
          pli.classList.remove('is-open');
          var pa = pli.querySelector(':scope > a.parent-link--true, :scope > a.parent-link--false');
          if (pa) pa.setAttribute('aria-expanded','false');
        }
      }
    });

    // Toggle actual
    if (isOpen) {
      submenu.style.display = 'none';
      li.classList.remove('is-open');
      a.setAttribute('aria-expanded','false');
    } else {
      submenu.style.display = 'block';
      li.classList.add('is-open');
      a.setAttribute('aria-expanded','true');
    }
  }

  // Captura pronto para ganar a los handlers del tema
  root.addEventListener('click', toggleSubmenu, true);
})();